import React from 'react';
import CurrencyInput from "../../elements/CurrencyInput.jsx";
import { updateSelectedDate } from "../../../redux/actions/dashboard.js";
import { useDispatch } from "react-redux";
import MoneyComponent from "react/elements/MoneyComponent";

const EditBudgetedAmountInput = React.memo(({
	                                            budget,
	                                            budgetInputRef,
	                                            onBlur,
	                                            budgetAmount,
	                                            copyBudgets,
	                                            usePreviousAmountValue,
	                                            budgetEdit,
	                                            categoryGroup,
	                                            budgetItemKeyPress,
	                                            isSubmittingBudgetAmountChange,
	                                            disabled,
	                                            rolloverBudgets,
	                                            rolloverAmount,
	                                            budgetSpent,
	                                            budgetAvailable,
                                            }) => {

	const dispatch = useDispatch();
	return (
		<React.Fragment>
			<CurrencyInput
				ref={budgetInputRef}
				allowNegative={true}
				value={budget.amount}
				onChange={budgetEdit}
				onKeyPress={budgetItemKeyPress}
				onBlur={onBlur}
				disabled={isSubmittingBudgetAmountChange || disabled}
				label='Budgeted'
			/>
			{copyBudgets && copyBudgets.length > 0 &&
			<div className='input-field'>
				<div className='category_summary use_previous_value'>
					<div className=''>
						<select
							onChange={usePreviousAmountValue}
							value=''
							className='browser-default'>
							<option value=''>
								Use Previous Value
							</option>
							{copyBudgets.map((budget, index) => (
								<option
									key={budget.id}
									value={index}>
									{`${budget.getSummary(categoryGroup)}`}
								</option>
							))}
						</select>
					</div>
				</div>
			</div>
			}
			{rolloverBudgets.length > 0 &&
			<div className='rolling_over_since'>
				<div>
					Rolling over since{' '}
					<a onClick={() => {
						dispatch(updateSelectedDate(rolloverBudgets[0].date));
					}}>
						{rolloverBudgets[0].date.format('MMMM YYYY')}
					</a>
				</div>
				<div>
					<MoneyComponent amount={rolloverAmount} /> From Rollover
				</div>
			</div>
			}
			{budget.amount !== undefined &&
			<div>
				<MoneyComponent amount={budget.amount} /> Budgeted
			</div>
			}
			{budgetSpent !== undefined &&
			<div>
				<MoneyComponent flipPositivity amount={budgetSpent} /> Spent
			</div>
			}
			{budgetAvailable !== undefined &&
			<div>
				<MoneyComponent amount={budgetAvailable} /> Budget Remaining
			</div>
			}
		</React.Fragment>
	);
});

export default EditBudgetedAmountInput;